import { newSpecPage } from '@stencil/core/testing';
import { LegrandavChatComponent } from '../legrandav-chat-component';

describe('legrandav-chat-component', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [LegrandavChatComponent],
      html: `<legrandav-chat-component></legrandav-chat-component>`,
    });
    expect(page.root).toEqualHtml(`
      <legrandav-chat-component>
        <mock:shadow-root>
          <slot></slot>
        </mock:shadow-root>
      </legrandav-chat-component>
    `);
  });
});
